import { render, staticRenderFns } from "./Pay-order-payment-methods.vue?vue&type=template&id=36ec4a34&scoped=true"
import script from "./Pay-order-payment-methods.vue?vue&type=script&lang=js"
export * from "./Pay-order-payment-methods.vue?vue&type=script&lang=js"
import style0 from "./Pay-order-payment-methods.vue?vue&type=style&index=0&id=36ec4a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec4a34",
  null
  
)

export default component.exports